<div class="row">
  <div class="col-lg-7 description-container">
    <div class="heading">
      <div class="logo">
        <div class="img" *ngIf="data?.overview?.adDomain">
          <img class="app-details-logo-2" src="https://logo.clearbit.com/{{data?.overview?.adDomain}}?size=96"
            (error)="handleError($event)" alt="Domain Details Logo" />
        </div>
        <div class="title-cont" *ngIf="data?.overview?.adDomain">
          <div class="title" [attr.title]="data?.overview?.adDomain">
            <a class="btn btn-link" target="_blank" href="{{data?.overview?.adDomain | urlfix}}">
              {{data?.overview?.adDomain}} <i class="fa fa-external-link"></i>
            </a>
          </div>
          <div class="info-cont">
            <div class="info" [hidden]="loading" *ngIf="data?.overview?.iabPrimaryCategory[0]">
              <div class="category">
                <div class="label">IAB Primary Category</div>
                <div class="value">
                  <ng-container *ngIf="_userService.appDiscoveryEnabled()">
                    <a class="btn btn-link p-0"
                      (click)="goToAppDiscovery('iabPrimaryCategory', data?.overview?.iabPrimaryCategory[0])">
                      {{data?.overview?.iabPrimaryCategory[0]}}
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!_userService.appDiscoveryEnabled()">
                    {{data?.overview?.iabPrimaryCategory[0]}}
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="info" [hidden]="loading" *ngIf="data?.overview?.iabSubCategory[0]">
              <div class="category">
                <div class="label">IAB Subcategory</div>
                <div class="value">
                  <ng-container *ngIf="_userService.appDiscoveryEnabled()">
                    <a class="btn btn-link p-0"
                      (click)="goToAppDiscovery('iabSubCategory', data?.overview?.iabSubCategory[0])">
                      {{data?.overview?.iabSubCategory[0]}}
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!_userService.appDiscoveryEnabled()">
                    {{data?.overview?.iabSubCategory[0]}}
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="flag-cont">
              <div class="category appstore-flag">
                <div class="value exists-{{data?.overview?.isAdsDotTxtExist}}">
                  <i class="fa"
                    [ngClass]="{'fa-check-circle': data?.overview?.isAdsDotTxtExist, 'fa-times-circle': !data?.overview?.isAdsDotTxtExist}"></i>
                  <span class="appstore-flag-label">Ads.txt</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center mt-2">
      <div class="d-flex align-items-center mr-4">
        <ng-container>
          <button [disabled]="processingFollow" class="btn btn-primary" #followButton [class.btn-follow]="!isFollowing"
            [class.btn-unfollow]="isFollowing" (click)="followButtonClick.emit( $event )">
            <i class="fa fa-check mr-1" *ngIf="isFollowing"></i>
            <i class="fa fa-plus mr-1" *ngIf="!isFollowing"></i>
            {{ isFollowing ? "Following" : "Follow" }}
          </button>
        </ng-container>
        <ng-container *ngIf="!processingFollow && numWatching >= 0">
          <label class="watching-count-label">{{numWatching}} Follower<span
              *ngIf="numWatching==0 || numWatching > 1">s</span></label>
        </ng-container>
        <ng-container *ngIf="processingFollow">
          <i style="position:relative;margin:0" class="fa fa-spin fa-spinner ml-2"></i>
        </ng-container>
      </div>
      <!-- <div class="viewcount-cont" *ngIf="viewCount >= 0">
        {{viewCount | num}} view<span *ngIf="viewCount > 1 || viewCount === 0">s</span>
      </div> -->
    </div>
  </div>
</div>
